import { page } from '@/lib/analytics';

export function segmentPlugin(page) {
  function update() {
    // Timeout hack to address the issue here: https://github.com/vuejs/vue-router/issues/2079
    // Will ensure the route finishes loading before tracking the page.
    setTimeout(page, 0);
  }

  function install(router) {
    router.afterEach(update);
  }

  return { install, update };
}

export default segmentPlugin(page).install;
